import { createContext } from "react";
import type { ServerErrors } from "@/types/ServerError";
import type { ErrorProcessor } from "@/types/ErrorProcessor";

export type ErrorProcessingContextType = {
  registerProcessor: (processor: ErrorProcessor) => void;
  unregisterProcessor: (processor: ErrorProcessor) => void;
  processErrors: (serverErrors: ServerErrors) => {
    captured: boolean;
    processorName?: string;
  };
};

export const ErrorProcessingContext =
  createContext<ErrorProcessingContextType | null>(null);
